'use strict';

var KeytransformDatastore = require('./keytransform');

var ShardingDatastore = require('./sharding');

var MountDatastore = require('./mount');

var TieredDatastore = require('./tiered');

var NamespaceDatastore = require('./namespace');

var shard = require('./shard');

exports.KeytransformDatastore = KeytransformDatastore;
exports.ShardingDatastore = ShardingDatastore;
exports.MountDatastore = MountDatastore;
exports.TieredDatastore = TieredDatastore;
exports.NamespaceDatastore = NamespaceDatastore;
exports.shard = shard;